import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <>
      {/* Main Hero */}
      <section className="relative bg-[#1B2A4A] text-white overflow-hidden" data-id="element-71">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 mix-blend-overlay" data-id="element-72"></div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 lg:pt-24 lg:pb-32 relative z-10" data-id="element-73">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-74">
            {/* Text Content */}
            <div className="space-y-8 text-center lg:text-left" data-id="element-75">
              <div className="inline-block px-4 py-1.5 rounded-full border border-[#C9A84C]/30 bg-[#C9A84C]/10 backdrop-blur-sm" data-id="element-76">
                <span className="text-[#C9A84C] font-medium tracking-wide text-sm uppercase" style={{
                fontSize: '10px'
              }} data-id="element-77">
                  Sistema 3C — Credibilidad · Claridad · Cierre
                </span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold leading-tight text-white" data-id="element-78">
                Buscas. Llamas. Escribes... <br className="hidden lg:block" data-id="element-79" />
                <span className="text-[#C9A84C]" data-id="element-80">
                  Y el piso se lo queda otro.
                </span>
              </h1>

              <p className="text-xl text-gray-300 font-light max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-81">
                La carpeta que te convierte en el{' '}
                <strong className="text-white font-medium" data-id="element-82">
                  "inquilino ideal"
                </strong>{' '}
                para las agencias y los propietarios desde el primer mensaje.
                Deja de perder oportunidades, haz que te elijan.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start pt-4" data-id="element-83">
                <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth'
              })} className="w-full sm:w-auto px-10 py-5 bg-[#C9A84C] hover:bg-[#b0903c] text-[#1B2A4A] font-extrabold text-xl rounded-xl transition-colors shadow-lg shadow-[#C9A84C]/20 flex items-center justify-center gap-3 tracking-tight cursor-pointer" style={{
                fontSize: '18px'
              }} data-id="element-84">
                  Quiero Dejar de Perder Pisos →
                </button>
              </div>

              <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-2 text-sm text-gray-400" data-id="element-85">
                <span className="flex items-center gap-1.5" data-id="element-86">
                  <CheckCircle2 className="w-4 h-4 text-[#C9A84C]" data-id="element-87" /> Pago único
                </span>
                <span className="flex items-center gap-1.5" data-id="element-88">
                  <CheckCircle2 className="w-4 h-4 text-[#C9A84C]" data-id="element-89" />{' '}
                  Implementación en 72h
                </span>
                <span className="flex items-center gap-1.5" data-id="element-90">
                  <CheckCircle2 className="w-4 h-4 text-[#C9A84C]" data-id="element-91" /> Plantillas
                  copy/paste
                </span>
              </div>
            </div>

            {/* Product Image */}
            <div className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-92">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-2" data-id="element-93">
                <img src="https://cdn.magicpatterns.com/uploads/sqDD5DKiu4mLkfoZW5GCXP/heylloyd-image-1770834594199.png" alt="Carpeta de Alquiler Imposible en iPad" className="w-full h-auto rounded-xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-94" />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#C9A84C] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" data-id="element-95"></div>
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" data-id="element-96"></div>
            </div>
          </div>
        </div>

        {/* Curve divider */}
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-[#FAFAF7] rounded-t-[50%_100%] transform scale-x-150 translate-y-8" data-id="element-97"></div>
      </section>

      {/* Opening Lead - Emotional Narrative */}
      <section className="bg-[#FAFAF7] py-20 px-4 sm:px-6" data-id="element-98">
        <div className="max-w-2xl mx-auto space-y-8 text-lg sm:text-xl leading-relaxed text-gray-800 font-serif" data-id="element-99">
          <p className="first-letter:text-5xl first-letter:font-bold first-letter:text-[#1B2A4A] first-letter:mr-2 first-letter:float-left" data-id="element-100">
            Te pasa esto y lo sabes: encuentras un piso decente, llamas rápido,
            haces la visita… y aun así te quedas fuera.
          </p>

          <p data-id="element-101">
            No porque seas mala persona. No porque no trabajes. Ni siquiera
            porque no puedas pagar.
          </p>

          <p className="font-medium text-[#1B2A4A]" data-id="element-102">
            Te quedas fuera porque, en un mercado con demanda salvaje, el
            propietario o la agencia no está buscando "al mejor".
          </p>

          <div className="border-l-4 border-[#C9A84C] pl-6 py-2 my-8 bg-[#FDF8EE] rounded-r-lg" data-id="element-103">
            <p className="italic text-gray-700" data-id="element-104">
              Está buscando al que le dé menos miedo y menos trabajo.
            </p>
          </div>

          <p data-id="element-105">
            Y si tu documentación llega a trozos, tarde, con explicaciones
            largas, o con huecos… ya está.
          </p>

          <p className="text-center font-bold text-[#1B2A4A] text-2xl mt-8" data-id="element-106">
            Ni te lo discuten. Te silencian.
          </p>
        </div>
      </section>
    </>;
}